import React from "react";

export default function DeveloperSettingsForm(props) {
  const { developerMode, setDeveloperMode } = props;

  return (
    <section className="overflow-hidden rounded-2xl border border-border-subtle bg-card shadow-soft">
      <div className="border-b border-border-subtle px-6 py-5">
        <h2 className="text-base font-semibold text-brand">Developer settings</h2>
        <p className="mt-1 text-sm text-slate-500">
          Local preferences for development and debugging tools.
        </p>
      </div>

      <div className="space-y-5 p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-gray-900">Developer mode</p>
            <p className="mt-1 text-sm text-slate-500">
              Shows barcode previews on detail screens.
            </p>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked={developerMode}
            aria-label="Developer mode"
            onClick={() => setDeveloperMode(!developerMode)}
            className={`${
              developerMode ? "bg-brand" : "bg-gray-200"
            } relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2`}
          >
            <span
              aria-hidden="true"
              className={`${
                developerMode ? "translate-x-5" : "translate-x-0"
              } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
            />
          </button>
        </div>
      </div>
    </section>
  );
}
